export enum TabRoute {
  Home = '/',
  Activities = '/activities/unassigned',
  OpenActivities = '/activities/open',
  Services = '/services',
  Servicesv2 = '/services/v2',
  ServiceSeries = '/service-series',
  ServiceTemplates = '/service-templates',
  ServiceSeriesv2 = '/service-series/v2',
  Shifts = '/shifts',
  ShiftSeries = '/shift-series',
  ShiftSeriesV2 = '/shift-series-v2',
  ShiftPlan = '/shift-plan',
  ShiftTemplates = '/shift-templates',
  ShiftDisposition = '/shift-disposition',
  ShiftTimeline = '/shift-timeline',
  OperativeReports = '/operative-reports',
  OperationsBoard = '/operations-board',
  Absences = '/absences',
  Employees = '/employees',
  QualificationsManagement = '/qualifications-management',
  QualificationsManagementV2 = '/qualification-management/v2',
  QualificationsManagementV2Overview = '/qualification-management/v2/overview',
  QualificationsManagementV2Shared = '/qualification-management/v2/shared',
  QualificationsManagementV2Training = '/qualification-management/v2/training',
  QualificationsManagementV2Profiles = '/qualification-management/v2/profiles',
  VacationManagement = '/vacation-management',
  VacationManagementv2 = '/vacation-management/v2',
  Locations = '/locations',
  WorkTimeManagement = '/work-time-management',
  Payroll = '/payroll',
  Overtime = '/overtime',
  Settings = '/settings',
  Invoicing = '/invoicing',
  Invoices = '/invoices',
  Products = '/products',
  InvoicingDetail = '/invoicing/detail',
  Share = '/share',
  MyJobs = '/share/jobs/client',
  CompanyProfile = '/share/company-profile',
  ExternalJobs = '/share/jobs/provider',
  Projects = '/projects',
  Stays = '/stays',
  PayrollSettings = '/settings/payroll-settings',
  WorkingTimeSettings = '/settings/working-time-model',
  CompanyContracts = '/settings/contract',
  TrainingProviders = '/settings/training-providers',
  WorkingTimeMonthlyView = '/working-times-monthly-view',
}
